import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-page-empty',
    templateUrl: './page-empty.component.html'
})
export class PageEmptyComponent implements OnInit {
    /* 
        Just an empty page component that can be used instead of places where
        we've previously used the PageNotFoundComponent. When we added content
        to the 404 page we needed a new component to display before landing
        page has been resolved. 
    */

    constructor() {}

    ngOnInit() {}
}
